import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
    name: 'lineStopsSetting',
    initialState: {
        isRequesting: false,
        error: null,
        isDone: false,
        data: null,
    },
    reducers: {
        update_line_stops_setting: (state) =>{
            return {
                ...state,
                isRequesting: true,
                isDone: false,
                error: null,
            };
        },
        update_line_stops_setting_failed: (state,action) =>{
            return {
                ...state,
                isRequesting: false,
                isDone: true,
                error: action.payload,
                data: null
            };
        },
        update_line_stops_setting_succeed: (state) =>{
            return {
                ...state,
                isRequesting: false,
                error: null,
                isDone: true,
            };
        },
    }
});

export const { reducer, actions } = slice;

export default reducer;